import React, { useEffect, useState } from 'react';
import { Loader2, Image as ImageIcon } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import ImageUploadField from './ImageUploadField';
import { adminVehicleBrandsAPI } from '../services/api';

/** Logo of a vehicle brand : upload from the computer (drag & drop / file picker) or paste a URL. */
const VehicleBrandLogoDialog = ({ brand, onClose, onSaved }) => {
  const [logo, setLogo] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => { setLogo(brand?.logo || ''); }, [brand]);

  const save = async (value) => {
    setSaving(true);
    try {
      await adminVehicleBrandsAPI.update(brand.name, { logo: value || '' });
      toast.success(value ? `Logo ${brand.name} enregistré` : `Logo ${brand.name} retiré`);
      onSaved?.();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Enregistrement impossible');
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={!!brand} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="vehicle-brand-logo-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ImageIcon size={18} className="text-orange-500" /> Logo — {brand?.name}</DialogTitle>
          <DialogDescription>Déposez un fichier depuis votre ordinateur (JPG, PNG, WebP, GIF · 5 Mo max) ou collez l'URL d'une image. Fond transparent recommandé.</DialogDescription>
        </DialogHeader>
        <ImageUploadField value={logo} onChange={setLogo} testId="vehicle-brand-logo" label="Logo de la marque" />
        <DialogFooter className="gap-2 sm:justify-between">
          <Button type="button" variant="ghost" className="text-red-600 hover:text-red-700" disabled={saving || !brand?.logo} onClick={() => save('')} data-testid="vehicle-brand-logo-remove">Retirer le logo</Button>
          <div className="flex gap-2">
            <Button type="button" variant="outline" onClick={onClose} disabled={saving} data-testid="vehicle-brand-logo-cancel">Annuler</Button>
            <Button type="button" onClick={() => save(logo)} disabled={saving || !logo} data-testid="vehicle-brand-logo-save" className="bg-orange-500 hover:bg-orange-600 text-white">
              {saving ? <Loader2 size={14} className="mr-1 animate-spin" /> : null} Enregistrer
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default VehicleBrandLogoDialog;
